import {Component} from 'react';

import platformConfig from '/config/platform.config';
import {withPopup} from '/provider/PopupProvider';
import {withTranslation} from '/provider/TranslationProvider';
import {isProdEnvironment} from '/util/env.util';
import {withHOC} from '/util/hoc.util';

import {UpdateAlertProviderUtil} from './UpdateAlertProvider.util';

interface UpdateAlertProviderProps {
  children: React.ReactNode;
}

export class UpdateAlertProvider extends Component<UpdateAlertProviderProps> {
  checkForUpdates: any;

  constructor(...args: any[]) {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super(...args);
    const {checkForUpdates} = new UpdateAlertProviderUtil(this.props);
    this.checkForUpdates = checkForUpdates;
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidMount() {
    // Check for update only in non-Dev environment.
    // Comment out `if` statement,
    // if you need update alerts to be shown within development.
    if (isProdEnvironment() && platformConfig.getOS() !== 'web') {
      this.checkForUpdates();
    }
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {children = null} = this.props;
    return children;
  }
}

export default withHOC(withPopup(), withTranslation(''))(UpdateAlertProvider);
